// Documentation ----> https://popper.js.org/
import React, { useState, useEffect } from 'react';
import reactDom from 'react-dom';
import { usePopper } from 'react-popper';
import './Popup.scss';

const Popup = (props) => {
	const { delay, disabled, className, offsetY, offsetX, triggerElement, popupElement, popupElementClass, hoverOnly, onClick, absolute, popupOuterWidth, placement, display, children, zIndex, relative, popupOuterClass, popupOuterStyle, onClickFunction, closeOnOutsideClick, onOutsideClick, stopClickEfect, isVisible } = props;

	const [referenceElement, setReferenceElement] = useState(null);
	const [popperElement, setPopperElement] = useState(null);
	const [mouseLeaveTimer, setMouseLeaveTimer] = useState(null)
	const [mouseEnterTimer, setMouseEnterTimer] = useState(null)
	const [popupVisible, setPopupVisible] = useState(false);

	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement: placement ? placement : "bottom-start",
		strategy: absolute ? "" : "fixed",
		modifiers: [{ name: "offset", options: { offset: [offsetX ? offsetX : 0, offsetY ? offsetY : 4] } }],
	});

	const handleEscKey = (event) => {
		if (closeOnOutsideClick) {
			if (event.key === 'Escape') {
				closeOnOutsideClick && setPopupVisible(false);
				onOutsideClick && onOutsideClick()
			}
		}
	};

	const handleClickOutside = (event) => {
		let updatedPopperElement;
		setPopperElement(popperElement => {
			updatedPopperElement = popperElement;
			return popperElement;
		})

		if ((updatedPopperElement && !updatedPopperElement.contains(event.target))) {
			closeOnOutsideClick && setPopupVisible(false);
			onOutsideClick && onOutsideClick()
		}
	};

	useEffect(() => {
		if (closeOnOutsideClick) {
			document.addEventListener('keydown', handleEscKey, true);
			document.addEventListener('click', handleClickOutside, true);
			return () => {
				document.removeEventListener('keydown', handleEscKey, true);
				document.removeEventListener('click', handleClickOutside, true);
			};
		}
	}, []);

	useEffect(() => {
		(isVisible === true || isVisible === false) && setPopupVisible(isVisible)
	}, [isVisible])

	const handleMouseEnter = () => {
		if (disabled) {
			return;
		} else if (hoverOnly) {
			clearTimeout(mouseLeaveTimer)
			if (delay) {
				setMouseEnterTimer(setTimeout(() => {
					setPopupVisible(true)
				}, delay))
			} else {
				setPopupVisible(true)
			}
		}
	}

	const handleMouseLeave = () => {
		clearTimeout(mouseEnterTimer)
		if (disabled) {
			return;
		} else if (hoverOnly) {
			setMouseLeaveTimer(setTimeout(() => {
				setPopupVisible(false)
			}, 100))
		}
	}

	const popUpChild = (
		<div
			className={`popup-element-outer${popupElementClass ? " " + popupElementClass : ""}`}
			onClick={(e) => { 
				if (stopClickEfect) {
					e.stopPropagation()
				} else {
					onClickFunction && onClickFunction()
					setPopupVisible(!popupVisible)
				}
			}}
			ref={setPopperElement}
			style={{ ...styles.popper, width: popupOuterWidth, zIndex: zIndex }}
			{...attributes.popper}
		>
			{React.cloneElement(popupElement)}
		</div>
	);


	return (
		<div
			style={{ display: display ? display : "", ...popupOuterStyle }}
			className={`popup-outer fade-down${className ? " " + className : ""}${relative ? " popup-relative" : ""} ${popupOuterClass ? " " + popupOuterClass : ""}`}
			onMouseEnter={() => handleMouseEnter()}
			onMouseLeave={() => handleMouseLeave()}
		>
			<div
				style={{display: "flex", alignItems: "center"}}
				className="popup-outer-inner"
				onClick={
					hoverOnly
						? null
						: hoverOnly && onClick
							? onClick
							: () => {
								setPopupVisible(!popupVisible);
								onClick && onClick();
							}
				}
				ref={setReferenceElement}
			>
				{triggerElement ? triggerElement : children}
			</div>
			{(popupVisible && absolute) ? popUpChild : popupVisible && reactDom.createPortal(popUpChild, document.querySelector("#tooltip-portal"))}
		</div>
	);
};

export default Popup;